import { render, staticRenderFns } from "./PduoduoConf.vue?vue&type=template&id=81f1b330&scoped=true"
import script from "./PduoduoConf.vue?vue&type=script&lang=js"
export * from "./PduoduoConf.vue?vue&type=script&lang=js"
import style0 from "./PduoduoConf.vue?vue&type=style&index=0&id=81f1b330&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f1b330",
  null
  
)

export default component.exports